var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"smileys-container"},[_c('transition-group',{attrs:{"name":"slide"},on:{"after-enter":_vm.afterEnter}},_vm._l((_vm.smileys),function(smiley){return _c('smiley',{key:smiley.id,attrs:{"id":smiley.id,"code":smiley.code,"right":smiley.right}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }